import { useSetAtom } from "jotai";
import { storePogNotesModalAtom, type StorePogNotesModalData } from "./atoms";
import { useModals } from "src/components/Modals";
import { useEffect } from "react";

export const useStorePogNotesModal = () => {
  const { openModal } = useModals();

  const setData = useSetAtom(storePogNotesModalAtom);

  useEffect(() => {
    setData(null);
  }, []);

  const openStorePogNotesModal = (data: StorePogNotesModalData) => {
    setData(data);
    openModal("StorePogNotesModal");
  };

  return { openStorePogNotesModal };
};
